import { render } from "./page-main.vue?vue&type=template&id=45d3b525&scoped=true"
import script from "./page-main.vue?vue&type=script&lang=js"
export * from "./page-main.vue?vue&type=script&lang=js"

import "./page-main.vue?vue&type=style&index=0&id=45d3b525&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d3b525"]])

export default __exports__